import { Box, styled, Theme } from "@mui/material";
import { IStyledIconWrapperProps } from "./types";

type IconWrapperColor = 'primary' | 'secondary' | 'tertiary' | 'neutral' | 'quaternary' | 'error' | 'success';

const pickColor = (theme?: Theme): Record<IconWrapperColor, any> => ({
    primary: (theme as any).palette?.primary?.darker,
    secondary: (theme as any).palette?.secondary?.main,
    tertiary: (theme as any).palette?.tertiary?.main,
    neutral: (theme as any).palette?.neutral?.lighter,
    quaternary: (theme as any).palette?.tertiary?.light,
    error: (theme as any).palette?.accentError.main,
    success: (theme as any).palette?.accentSuccess.main

})

const StyledIconWrapper = styled(Box, {
    shouldForwardProp: prop => prop !== 'customColor'
})<IStyledIconWrapperProps>(({ theme, customColor = 'primary' }) => {
    const allowedColors: IconWrapperColor[] = ['primary', 'secondary', 'tertiary', 'neutral', 'quaternary', 'error', 'success'];
    const key: IconWrapperColor = allowedColors.includes(customColor) ? customColor : 'primary';

    return ({
        margin: "0px",
        padding: "0px",
        display: "flex",
        alignItems: "center",
        "& .MuiSvgIcon-root": {
            color: `${pickColor(theme)[key]} !important`
        }
    })
})

export { StyledIconWrapper }